import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../redux/actions/ApplicationAction";
import notify from "../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Electric = () => {
  const [desc, setdesc] = useState("");
  const [Nationalid, setNationalid] = useState([]);
  const [ChoseMain, setChoseMain] = useState("");
  const [ChoseSub, setChoseSub] = useState("");
  const [sanadmilk, setsanadmilk] = useState("");
  const [sadad, setsadad] = useState("");
  const [marafic, setmarafic] = useState("");
  const [mahder, setmahder] = useState("");
  const [TanazolNatid, setTanazolNatid] = useState([]);

  const [Others, setOthers] = useState([]);
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };
  const handleFileChangeTanazol = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setTanazolNatid(files);
  };
  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      Nationalid === "" ||
      ChoseMain === "" ||
      ChoseMain === 1 ||
      ChoseMain === 2 ||
      ChoseMain === 3 ||
      ChoseMain === 4
        ? ChoseSub === ""
        : null
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 8);
    formData.append("transaction_company", 'electricity');
    formData.append("transaction_type", ChoseMain);
    formData.append("transaction_category", ChoseSub);
    formData.append("transaction_details", desc);
    formData.append("recored ", mahder);
    formData.append("payment_receipt_last_transaction", sadad);
    formData.append("facilities_receipt", marafic);
    formData.append("title_deed ", sanadmilk);
    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });
    TanazolNatid.map((item) => {
      return formData.append("assigned_national_identification_number", item);
    });
    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setdesc("");
    setNationalid("");
    setOthers("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">خدمات الكهرباء</h3>
      <div className="inputs-container">
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الطلب
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الطلب
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseMain}
              onChange={(e) => setChoseMain(e.target.value)}
            >
              <MenuItem value={1}>خدمات تركيب العداد</MenuItem>
              <MenuItem value={2}>توصيل التيار الكهربي </MenuItem>
              <MenuItem value={3}>طلبات استخراج </MenuItem>
              <MenuItem value={4}>تصحيح البيانات </MenuItem>
              <MenuItem value={5}>استبدال عداد بقدره اكبر </MenuItem>
              <MenuItem value={6}>تنازل عن العداد </MenuItem>
              <MenuItem value={7}>تسجيل قراءه العداد </MenuItem>
              <MenuItem value={8}>جدوله مديونيه متاخره</MenuItem>
        
            </Select>
          </FormControl>
        </div>
        {ChoseMain === 1 ? (
          <>
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {
                    <Typography>
                      نوع الطلب
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <Typography>
                      نوع الطلب
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  value={ChoseSub}
                  onChange={(e) => setChoseSub(e.target.value)}
                >
                  <MenuItem value={1}>تركيب عداد لأول مرة</MenuItem>
                  <MenuItem value={2}>تركيب عداد ممارسة</MenuItem>
                  <MenuItem value={3}>تركيب عداد بدل فاقد</MenuItem>
                </Select>
              </FormControl>
            </div>
          </>
        ) : ChoseMain === 2 ? (
          <>
            {" "}
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {
                    <Typography>
                      نوع الطلب
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <Typography>
                      نوع الطلب
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  value={ChoseSub}
                  onChange={(e) => setChoseSub(e.target.value)}
                >
                  <MenuItem value={4}>عداد انشائي</MenuItem>
                  <MenuItem value={5}>عداد للمباني السكنية</MenuItem>
                  <MenuItem value={6}>
                    عداد للمشروعات الصغيرة او المتوسطة
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
          </>
        ) : ChoseMain === 3 ? (
          <>
            {" "}
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {
                    <Typography>
                      نوع الطلب
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <Typography>
                      نوع الطلب
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  value={ChoseSub}
                  onChange={(e) => setChoseSub(e.target.value)}
                >
                  <MenuItem value={7}>شهادة بيان تعاقد</MenuItem>
                  <MenuItem value={8}>شهادة استهلاك</MenuItem>
                  <MenuItem value={9}>كارت بدل فاقد</MenuItem>
                </Select>
              </FormControl>
            </div>
          </>
        ) : ChoseMain === 4 ? (
          <>
            {" "}
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {
                    <Typography>
                      نوع الطلب
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <Typography>
                      نوع الطلب
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  value={ChoseSub}
                  onChange={(e) => setChoseSub(e.target.value)}
                >
                  <MenuItem value={10}>صاحب العداد</MenuItem>
                  <MenuItem value={11}>قراءة العداد</MenuItem>
                </Select>
              </FormControl>
            </div>
          </>
        ) : null}
  <div className="inp-container ">
          <TextField
            label={
              <Typography>
                البطاقة الشخصية
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeNational}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"سند الملكية"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setsanadmilk(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"إيصال سداد لأخر عملية"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setsadad(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"إيصال المرافق"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setmarafic(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"محضر شرطة"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setmahder(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"بطاقة المتنازل والمتنازل الية"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeTanazol}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"تفاصيل"}
            multiline
            type="text"
            value={desc}
            onChange={(e) => {
              setdesc(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"اخرى"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeOther}
            variant="outlined"
          />
        </div>
        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Electric;
